import { ReactNode } from 'react';

import { EventListTab } from '@features/club/typings';

export type ITab<T = string> = { value: T; label: ReactNode };

export const TABS: ITab<EventListTab>[] = [
  { value: 'upcoming', label: 'Ближайшие' },
  { value: 'finished', label: 'Прошедшие' },
  { value: 'drafts', label: 'Черновики' },
];
